import {
  commentsAuthEndpoint,
  resolveMentionSuggestions,
  resolveUsers,
  settleSessionTenant,
} from './comments.config'
import { getCurrentTenant, getSessionToken, useSession, useUser } from '@descope/react-sdk'
import { ClientContext } from '@liveblocks/react'
import { PropsWithChildren, useContext, useEffect } from 'react'

import { CommentsLiveblocksProvider } from './comments-liveblocks-provider'

const readTenant = (token: string) => {
  try {
    return getCurrentTenant(token) || ''
  } catch {
    return ''
  }
}

// listUsers fails until selectTenant has written the org onto the session, and Liveblocks
// will not ask for those authors again. Hold the directory read until the session settles.
const useSettleSessionTenant = () => {
  const { sessionToken, isSessionLoading } = useSession()
  const { user, isUserLoading } = useUser()

  useEffect(() => {
    if (isSessionLoading || isUserLoading) return
    const token = getSessionToken() || sessionToken
    const tenant = token ? readTenant(token) : ''
    if (tenant || !user?.userTenants?.length) settleSessionTenant()
  }, [sessionToken, isSessionLoading, isUserLoading, user])
}

// The internal (tenant) surfaces authenticate to Liveblocks with the assessment token and
// resolve/mention internal users. The portal supplies its own provider with the portal token.
export const TenantCommentsProvider = ({ children }: PropsWithChildren) => {
  useSettleSessionTenant()
  const ancestorClient = useContext(ClientContext)
  if (ancestorClient) return children

  return (
    <CommentsLiveblocksProvider
      authEndpoint={commentsAuthEndpoint}
      resolveUsers={resolveUsers}
      resolveMentionSuggestions={resolveMentionSuggestions}
    >
      {children}
    </CommentsLiveblocksProvider>
  )
}
